module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_esfiha.7905f56c.png";